import React from 'react';
import PropTypes from 'prop-types';

const PayLinks = ({ altText }) => {
  return (
    <svg xmlns='http://www.w3.org/2000/svg' width='1.5em' height='1.5em' fill='none'>
      <title id='pay-links-title'>{altText}</title>
      <path fill='currentColor' d='M15.03 8.97a2.871 2.871 0 0 0-4.06 0l-1.5 1.5a.75.75 0 1 0 1.06 1.06l1.5-1.5a1.371 1.371 0 0 1 1.94 1.94l-1.5 1.5a.75.75 0 1 0 1.06 1.06l1.5-1.5a2.871 2.871 0 0 0 0-4.06ZM8.53 13.53a.75.75 0 1 0-1.06-1.06l-1.5 1.5a2.871 2.871 0 1 0 4.06 4.06l1.5-1.5a.75.75 0 1 0-1.06-1.06l-1.5 1.5a1.371 1.371 0 0 1-1.94-1.94l1.5-1.5Z'/>
      <path fill='currentColor' d='M12.53 11.47a.75.75 0 0 1 0 1.06l-3 3a.75.75 0 0 1-1.06-1.06l3-3a.75.75 0 0 1 1.06 0ZM18 15a1 1 0 1 0 0-2 1 1 0 0 0 0 2Z'/>
      <path fill='currentColor' fillRule='evenodd' d='M4.5 2.25A2.25 2.25 0 0 0 2.25 4.5v12c0 2.9 2.35 5.25 5.25 5.25h9c2.9 0 5.25-2.35 5.25-5.25v-6c0-2.9-2.35-5.25-5.25-5.25h-12a.75.75 0 0 1 0-1.5H18a.75.75 0 0 0 0-1.5H4.5Zm0 4.5h12a3.75 3.75 0 0 1 3.75 3.75v6a3.75 3.75 0 0 1-3.75 3.75h-9a3.75 3.75 0 0 1-3.75-3.75V6.622c.235.083.487.128.75.128Z' clipRule='evenodd'/>
    </svg>
  );
};

PayLinks.propTypes = {
  altText: PropTypes.string
};

export default PayLinks;
